// extracted by mini-css-extract-plugin
module.exports = {"varSpBase":"1rem","flip":"flip--f255e","wrapper":"wrapper--a4e1c","icon":"icon--39396"};